import type { FC } from "react";

import { ProductProfileSearchForm } from "src/app/features/ProductProfile/components/forms/ProductProfileSearchForm";
import { ProductProfilesTable } from "src/app/features/ProductProfile/components/tables/ProductProfilesTable";
import type { ProductProfileList } from "src/app/features/ProductProfile/types/ProductProfileList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const ProductProfilesPage: FC<NoneOwnProps> = () => {
    const table = <ProductProfilesTable />;
    const searchForm = <ProductProfileSearchForm />;
    const hasAccess = canAccess(ResourceName.PRODUCT_PROFILES, "canRead");

    return (
        <PageLayout name="productProfiles_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.productProfiles" />
                    <ResourceManager<ProductProfileList>
                        useDataGroup
                        dataMapperKey="productProfilesTableData"
                        resource={ResourceName.PRODUCT_PROFILES}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.ADD, Actions.DELETE, Actions.COPY, Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
